'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhotoSizeSelectActual = function MdPhotoSizeSelectActual(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.4 28.4h23.2l-7.5-10-5.7 7.5-4.3-5z m26.6-23.4q1.3 0 2.3 1.1t1.1 2.3v23.2q0 1.3-1.1 2.3t-2.3 1.1h-30q-1.3 0-2.3-1t-1.1-2.4v-23.2q0-1.3 1.1-2.3t2.3-1.1h30z' })
        )
    );
};

exports.default = MdPhotoSizeSelectActual;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/photo-size-select-actual.js
// module id = 1331
// module chunks = 36573943044255 79611799117203 213534597649335